import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ProfileStateService } from 'app/shared/services/profile-state.service';

import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';

import { IButtonConfig } from 'app/shared/interfaces/button.interfaces';
import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { EButtonSizes, EButtonTypes } from 'app/shared/enums/button.enums';
import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { EUserCredential } from 'app/enums/profile.enums';

import { SUPPORT_LINK } from '../../../shared/const/app.constants';

@Component({
  selector: 'stxt-security',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './security.component.html',
  styleUrl: './security.component.scss'
})
export class SecurityComponent {
  @Input() userEmail: string;
  @Input() emailVerified: boolean;
  @Input() externalProvider: boolean;
  @Output() openManageScreen: EventEmitter<string> = new EventEmitter<string>();
  @Output() openVerifyScreen: EventEmitter<void> = new EventEmitter<void>();

  public connectBtnConfig: IButtonConfig = {
    text: 'Connect',
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Small
  };
  public supportLink: string = SUPPORT_LINK;
  public arrowSvgConfig: ISvgConfig = { name: 'arrow_right', fill: ESvgTypes.None };
  public verifiedSvgConfig: ISvgConfig = { name: 'done', fill: ESvgTypes.None };
  public notVerifiedSvgConfig: ISvgConfig = { name: 'info', fill: ESvgTypes.None };
  public verifiedSvg: ISvgConfig = { name: 'verified', fill: ESvgTypes.None };
  public notVerifiedSvg: ISvgConfig = { name: 'not-verified', fill: ESvgTypes.None };
  public editSvg: ISvgConfig = { name: 'pen', fill: ESvgTypes.None };
  public verifyButton: IButtonConfig = {
    text: 'Verify',
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Default
  };
  public editButton: IButtonConfig = {
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Default
  };
  protected readonly EUserCredential = EUserCredential;

  constructor(private readonly profileStateService: ProfileStateService) {}

  manageCredentials(): void {
    this.emailVerified ? this.openManageScreen.emit(EUserCredential.Email) : this.openVerifyEmail();
  }

  openVerifyEmail(): void {
    this.profileStateService.refreshProfileData();
    this.openVerifyScreen.emit();
  }

  navigateToManageEmail(): void {
    this.emailVerified ? this.openManageScreen.emit(EUserCredential.Email) : this.openVerifyEmail();
  }
}
